export const ALL_BUSINESS_SUBCATEGORIES = {
  "Agriculture, Forestry, Fishing": {
    "Agricultural Production - Crops": "0191",
    "Agricultural Production - Livestock": "0291",
    "Agricultural Services": "0781",
    Forestry: "0851",
    "Fishing, Hunting and Trapping": "0971",
  },

  Construction: {
    "General Contractors": "1522",
    "Heavy Construction": "1629",
    "Special Trade Contractor": "1799",
  },

  "Finance, Insurance, Real Estate": {
    "Depository Institutions": "6099",
    "Non-Depository Credit Institutions": "6159",
    "Securities and Commodoties": "6289",
    "Insurance Carriers": "6399",
    "Insurance Agents, Service": "6411",
    "Real Estate": "6531",
    "Holding and Other Investment": "6799",
  },

  Manufacturing: {
    "Food and Kindred Products": "2099",
    "Tobacco Products": "2141",
    "Textile Mill Products": "2299",
    "Apparel and Fabric Products": "2399",
    "Lumber and Wood": "2499",
    "Furniture and Fixtures": "2599",
    "Paper and Allied Products": "2679",
    "Printing, Publishing": "2741",
    "Chemicals and Allied Products": "2899",
    "Petroleum Refining": "2999",
    "Rubber and Plastics": "3089",
    "Leather and Leather Products": "3199",
    "Stone, Clay, Glass, Concrete": "3299",
    "Primary Metal Industries": "3399",
    "Fabricated Metal Products": "3499",
    "Industrial Machinery and Computers": "3599",
    "Electronic Equipment": "3699",
    "Transportation Equipment": "3799",
    "Measuring Instruments": "3873",
    "Other Manufacturing": "3999",
  },

  Mining: {
    "Metal Mining": "1099",
    "Bituminous Coal and Lignite Mining": "1241",
    "Oil and Gas Extraction": "1389",
    "Nonmetallic Minerals, Not Fuels": "1499",
  },

  "Public Administration": {
    "General Government, Not Finance": "9199",
    "Justice, Public Order, and Safety": "9229",
    "Finance, Tax, Monetary": "9311",
    "Human Resource Programs": "9441",
    "Housing and Environmental": "9531",
    "Administration of Economic Programs": "9611",
    "Inernational Affairs, Security": "9721",
    "Nonclassifiable Establishments": "9999",
  },

  "Retail Trade": {
    "Building, Hardware, Garden": "5211",
    "General Merchandise Stores": "5399",
    "Food Stores": "5499",
    "Auto Dealers, Gasoline Service": "5599",
    "Apparel and Accessory Stores": "5699",
    "Home Furnishings": "5712",
    "Eating and Drinking Places": "5812",
    "Miscellaneous Retail": "5999",
  },

  Services: {
    "Hotels & Lodging Places": "7011",
    "Personal Services": "7299",
    "Business Services": "7389",
    "Auto Services and Repair": "7538",
    "Miscellaneous Repair Services": "7699",
    "Motion Pictures": "7812",
    "Amusement and Recreation Services": "7999",
    "Legal Services": "8111",
    "Educational Services": "8299",
    "Social Services": "8399",
    "Museums, Galleries, Gardens": "8412",
    "Membership Organizations": "8699",
    "Accounting, Research, Management": "8748",
    "Private Households": "8811",
  },

  "Transportation & Public Utilities": {
    "Railroad Transportation": "4011",
    "Local Transportation": "4111",
    "Motor Freight Transportation": "4212",
    "United States Postal Service": "4311",
    "Water Transportation": "4499",
    "Transportation by Air": "4512",
    "Pipelines, except Natural Gas": "4619",
    "Transportation Services": "4789",
    Communications: "4899",
    "Electric, Gas and Sanitary Services": "4931",
  },

  "Wholesale Trade": {
    "Wholesale Trade-Durable Goods": "5099",
    "Wholesale Trade-Nondurable Goods": "5199",
  },
};

export const ALL_BUSINESS_CATEGORIES: Array<string> = Object.keys(ALL_BUSINESS_SUBCATEGORIES);

// Values to put in field. Example: { Agriculture, Forestry, Fishing: "Agriculture, Forestry, Fishing", ...}
export const ALL_BUSINESS_CATEGORIES_FIELD_VALUES = ALL_BUSINESS_CATEGORIES.reduce((o, key) => Object.assign(o, { [key]: key }), {});

export const UNSUPPORTED_UHC_SIC_CODES = [
  "1011",
  "1020",
  "1021",
  "1030",
  "1031",
  "1040",
  "1041",
  "1044",
  "1060",
  "1061",
  "1080",
  "1081",
  "1090",
  "1094",
  "1099",
  "1200",
  "1220",
  "1221",
  "1222",
  "1230",
  "1231",
  "1240",
  "1241",
  "1411",
  "1420",
  "1422",
  "1423",
  "1429",
  "1440",
  "1442",
  "1446",
  "1450",
  "1455",
  "1459",
  "1470",
  "1474",
  "1475",
  "1479",
  "1480",
  "1481",
  "1490",
  "1499",
  "4111",
  "4119",
  "4120",
  "4121",
  "4130",
  "4131",
  "4140",
  "4141",
  "4142",
  "4150",
  "4151",
  "4170",
  "4173",
  "4311",
  "4412",
  "4420",
  "4424",
  "4430",
  "4432",
  "4440",
  "4449",
  "4480",
  "4481",
  "4482",
  "4489",
  "4490",
  "4491",
  "4492",
  "4493",
  "4499",
  "4512",
  "4513",
  "4520",
  "4522",
  "4580",
  "4581",
  "7361",
  "7363",
  "8631",
  "8699",
  "8811",
  "8999",
  "9999",
];

export const UNSUPPORTED_DISABILITY_SIC_CODES = [
  "0811",
  "0831",
  "0851",
  "0912",
  "0913",
  "0919",
  "0921",
  "0971",
  "1011",
  "1021",
  "1031",
  "1041",
  "1044",
  "1061",
  "1094",
  "1099",
  "1222",
  "1231",
  "1241",
  "2411",
  "2421",
  "2426",
  "2429",
  "2892",
  "3292",
  "3482",
  "3483",
  "4121",
  "4311",
  "4412",
  "4522",
  "4612",
  "4613",
  "4619",
  "5431",
  "5813",
  "7521",
  "7542",
  "7929",
  "7941",
  "7948",
  "7993",
  "7996",
  "7999",
  "9711",
  "9721",
];
